// @ts-nocheck
import {
    type LensCompoundId,
    type LensWithConnections,
    type VendorDataItem,
    type MyLensesLensStatus,
    type LenssourceModelLensSourceInfo as LensSourceInfo,
} from "../../../gql-generated/types";
import { DateConvert } from "../domain/services/DateConvert";
import { LensLabels } from "./LensLabels";

export class LensListItemModel {
    public readonly iconUrl: string;
    public readonly previewUrl: string;
    public readonly name: string;
    public readonly vendorData: readonly VendorDataItem[];
    public readonly compoundId: LensCompoundId;
    public readonly updatedAt: Date;
    public readonly groupNames: readonly string[];
    public readonly scheduleV3Alias: string;
    public readonly lensStatus: MyLensesLensStatus;
    public readonly minSdkVersion: string;
    public readonly minWebSdkVersion: string;
    public readonly hasMusic: boolean;
    public readonly lensSourceInfo: LensSourceInfo;
    public readonly videoUrl: string;
    public readonly previewWebpUrl: string;

    public static createFromLensWithConnections({
        lens: {
            iconUrl,
            name,
            vendorData,
            updatedAt,
            labels,
            compoundId,
            lensStatus,
            minSdkVersion,
            minWebSdkVersion,
            hasMusic,
            lensSourceInfo,
            previewUrl,
            videoUrl,
            previewWebpUrl,
        },
        connections,
    }: LensWithConnections): LensListItemModel {
        return {
            iconUrl,
            compoundId,
            name,
            vendorData,
            updatedAt: DateConvert.toDate(updatedAt),
            groupNames: connections.map((connection) => connection.group.name),
            scheduleV3Alias: LensLabels.getScheduleV3Alias(labels) ?? lensSourceInfo?.name,
            lensSourceInfo,
            lensStatus,
            minSdkVersion,
            minWebSdkVersion,
            hasMusic,
            previewUrl,
            videoUrl,
            previewWebpUrl,
        };
    }
}
